import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzxqedpmj7: FaireProductEntity = {
  token: "p_bzxqedpmj7",
  type: "product",
  name: "Turquoise Colorblock Edge Drop Shoulder T Shirt and Skort 2Pcs Set",
  brandToken: "b_fkehs24v39",
  brandName: "Sweet Lover Fashion",
  imageUrl:
    "https://cdn.faire.com/fastly/ab0873524859996fc8619ef034c9d2b9270c8a6b4ecd484789e1511aa1018ccc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/73af339b255bee48fa89fb6512d14a126c3948ca655d241c43fb6d28753e8a28.jpeg",
    "https://cdn.faire.com/fastly/2084597235fda835b6792862d70e5574e5b231c69bd5aa4a2df5e71c87b14840.jpeg",
    "https://cdn.faire.com/fastly/084eb7fd49a4ceb82b84b35edeb95f8ddd9fcfd20073ca7f98f90d3f0155956c.jpeg",
    "https://cdn.faire.com/fastly/8337af37825131c03b584f6cc42e97628b3765f765fec3a5db4cbfbb21316c1a.jpeg",
    "https://cdn.faire.com/fastly/71154e0b475515559dea8a31642942e41ea4416bd937f967a0d43b618fd779e2.jpeg",
    "https://cdn.faire.com/fastly/ecb099bc3a3166c7bd9bb4b10cbfd69e0762e4ae8641a110fa4e058fadd5f356.jpeg",
  ],
  priceDollars: 21.98,
  description:
    "This skort set is effortlessly stylish with a colorblock design.\nThe drop shoulder design is slouchy and casual.\nCoordinating skirt short is active and perfect to show sexy legs.\nVersatile pieces that can be worn together or separately.\n",
  tags: [],
  msrpDollars: 43.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:25.043Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
